import React from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'
import banner from "../../Assets/cover.png";
import CoverHero from '../CoverHero';
import ServiceShowcase from '../ServiceShowCase';
import Slider from 'react-slick';
import {
    serviceShowcaseData, heading1, paragraph1, spansacross, spansHeading, UsApart,
    UsApartHeading, UsAPartParagraph, physioData, endorsedData, settings3, physioSectionData
} from './Physio.js';
import CardsContainer from '../CardsContainer.jsx';
import physioimg from "../../Assets/physioimg.png"
import "./physio.css"
import Testimonials from '../../Testimonial/Testimonial.jsx';
import ServicesGrid from '../ServiceGrid';
import { useState } from 'react';
import LoginModal from '../../Modals/LoginModal.js';
import { useNavigate } from 'react-router-dom';

const Physiotherapy = () => {
    const navigate = useNavigate();

    return (
        <>
            <Header />
            <CoverHero image={banner} title="Physiotherapy" />

            <div className="servicesShowCase">
                {serviceShowcaseData.map((service, index) => (
                    <ServiceShowcase
                        key={index}
                        className="physio"
                        data={service}
                        onServiceClick={() => navigate('/')}
                    />
                ))}
            </div>

            <div className="texts-physio">
                <h2>{heading1}</h2>
                <p>{paragraph1}</p>
            </div>

            <CardsContainer
                heading={spansHeading}
                services={Object.values(spansacross)}
                className="physio-cardscontainer"
            />


            <div className="physio-section">
                <div className="physio-text">
                    <h1>{physioSectionData.heading}</h1>
                    <p>
                        {physioSectionData.paragraph}
                    </p>
                </div>

                <div className="physio-image">
                    <img src={physioimg} alt="Physiotherapy" />
                </div>
            </div>

            <CardsContainer
                className="us-apart"
                heading={UsApartHeading}
                paragraph={UsAPartParagraph}
                services={Object.values(UsApart)}
            />

            <div className="physio-testimonials-container">
                <Testimonials
                    data={physioData}
                    textKey="desc"
                    imgKey="userimg"
                    nameKey="username"
                    className="physio-testimonials"
                />
            </div>
            <div className="endorsed">
                <h2>Endorsed By</h2>
                <Slider {...settings3}>
                    {endorsedData.map((item, index) => (
                        <div key={index} className="endorse-card">
                            <img src={item.logo} alt={item.name} />
                        </div>
                    ))}
                </Slider>
            </div>
            <ServicesGrid title="Check Our Other Services" exclude="Physiotherapy" />



            <Footer />
        </>
    )
}

export default Physiotherapy
